/**
 * Presents the dispatch-approval choice when a selected delivery slot loses availability.
 * Shared by RMC Order Intake and Order Management flows.
 */

import { Button, Modal, ModalContent, ModalFooter, ModalTitle } from '@hm/fundamental'
import React from 'react'
import { useTranslation } from 'react-i18next'

export interface SlotValidityModalProps {
    isVisible: boolean
    onChangeStartTime: () => void
    onKeepStartTime: () => void
}

export const SlotValidityModal: React.FC<SlotValidityModalProps> = ({
    isVisible,
    onChangeStartTime,
    onKeepStartTime
}) => {
    const { t } = useTranslation()

    if (!isVisible) return null

    return (
        <Modal open={isVisible} onClose={onKeepStartTime} width="thin">
            <ModalTitle>
                {t('orderIntake.rmc.orderManagement.slotValidation.approvalRequiredTitle')}
            </ModalTitle>
            <ModalContent>
                <p className="text-sm text-gray-600">
                    {t('orderIntake.rmc.orderManagement.slotValidation.approvalRequiredMessage')}
                </p>
            </ModalContent>
            <ModalFooter>
                <div className="flex w-full gap-3">
                    <Button
                        variant="secondary"
                        onClick={onKeepStartTime}
                        className="flex-1"
                        data-test-id="slot-validity-modal-keep-start-time-button"
                    >
                        {t('orderIntake.rmc.orderManagement.slotValidation.keepStartTimeButton')}
                    </Button>
                    <Button
                        variant="primary"
                        onClick={onChangeStartTime}
                        className="flex-1"
                        data-test-id="slot-validity-modal-change-start-time-button"
                    >
                        {t('orderIntake.rmc.orderManagement.slotValidation.changeStartTimeButton')}
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}